import React, { Component } from 'react';
import ReactFileReader from 'react-file-reader';
import tr from '../../../libs/tr'
import Avatar from 'react-avatar';
import './MainPnl.css';
import CardPnl from "./CardPnl";
import ToggleBtn from "../toggle/ToggleBtn";
import profilee from '../../../images/public/userarea/profilee.png';
//import crdscia from '../../../images/public/userarea/crdscia.png';
//import crdsciblock from '../../../images/public/userarea/crdsciblock.png';
import alerts from '../../../images/public/userarea/alerts.png';
import alertblu from '../../../images/public/userarea/alertblu.png';
import pending from '../../../images/public/userarea/pending.png';
import uploadpicoverlay from '../../../images/public/userarea/uploadpicoverlay.png';
import ReactLoading from 'react-loading';
import moment from 'moment';
import { updateSkierPictureFetch, getServicePrice, setSkierPostalCode, getSkiers } from '../../../libs/fetch'
import Cookies from 'universal-cookie';
import Cleave from 'cleave.js/react';
const cookies = new Cookies();
// 
let activeSkier;
var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
});

class MainPnl extends Component {

  constructor(props) {
    super(props);

    this.state = {
      // Upload: props.Upload,
      // Block: props.Block,
      // Active: props.Active,
      // Activate: props.Activate, // has card to activate?
      // Paganella: props.Paganella, // ?? guess a station
      // Expired: props.Expired, // by default cart is not expired
      // // activeSkier info
      // activeSkier: '',
      // UploadAlert: props.UploadAlert,
      // // loaded data check

      isLoading: false,
      dualCards: false,
      remUpload: false, // It should be true when the user want to ski more than 8 days and should upload personal photo(check if user has(not) profile pic) TODO: @Ali
      pending: false, // It should be true when the user uploaded documents and waiting for the approval - upload btn disapearsTODO: @Ali
      loadedData: false,
      user: this.props.user,
      userPic: (this.props.user.length < 2) ? this.props.user[0].picture : (this.props.user[0].picture ? this.props.user[0].picture : this.props.user[1].picture),
      rinnovo_automatico: this.props.user[0].rinnovo_automatico,
      profileLoader: false,
      certified_postalcode: this.props.user[0].certified_postalcode,
      postalcode: this.props.user[0].postalcode ? this.props.user[0].postalcode : "",
      postalcode_variable: "",
    };

    console.log('MAINPNL PROPS', this.state.user)
    // this.onClick = this.onClick.bind(this);
    this.mpcallback = this.mpcallback.bind(this);
    // this.addPortaleToCards();
  }


  // // calculate user age from dateBirth data
  // // @return the age
  // calculate_age = () => {
  //     const today_date = new Date();
  //     const today_year = today_date.getFullYear();
  //     const today_month = today_date.getMonth();
  //     const today_day = today_date.getDate();

  //     let birthday = new Date(this.state.activeSkier.data_di_nascita);

  //     let age = today_year - birthday.getFullYear();

  //     if (today_month < (birthday.getMonth())) {
  //         age--;
  //     }
  //     if (((birthday.getMonth() - 1) == today_month) && (today_day < birthday.getDate())) {
  //         age--;
  //     }
  //     return age;
  // }

  //// set ActiveSkier
  // componentDidMount() {
  // this.forceUpdate(() => {
  //     try {
  //         activeSkier = JSON.parse(localStorage.getItem('activeSkier'));
  //         this.setState({ activeSkier: activeSkier });
  //         this.setState({ loadedData: true });
  //         // if (this.calculate_age() < 17) {
  //         //     this.setState({ UploadAlert: true });
  //         // }
  //     } catch (e) {
  //         console.error(e);
  //     }
  // });
  // }

  componentDidMount() {

    // Upload: props.Upload,
    // Block: props.Block,
    // Active: props.Active,
    // Activate: props.Activate, // has card to activate?
    // Paganella: props.Paganella, // ?? guess a station
    // Expired: props.Expired, // by default cart is not expired
    // // activeSkier info
    // activeSkier: '',
    // UploadAlert: props.UploadAlert,
    // // loaded data check

    // dualCards: props.dualCards,

    let user = this.state.user;
    //     // Active={this.isActive(this.state.activeSkier)}
    //     // Activate={this.isActivate(this.state.activeSkier)}
    //     // Block={this.isBlocked(this.state.activeSkier)}
    //     // Upload={this.canUpload(this.state.activeSkier)}
    //     // UploadAlert={this.mustUpload(this.state.activeSkier)}
    //     // Expired={this.isExpired(this.state.activeSkier)}

    if (user.length > 1) {
      let user_1 = {
        Active: this.isActive(user[0]),
        Activate: this.isActivate(user[0]),
        Block: this.isBlocked(user[0]),
        Upload: this.canUpload(user[0]),
        UploadAlert: this.mustUpload(user[0]),
        Expired: this.isExpired(user[0]),
      }
      let user_2 = {
        Active: this.isActive(user[1]),
        Activate: this.isActivate(user[1]),
        Block: this.isBlocked(user[1]),
        Upload: this.canUpload(user[1]),
        UploadAlert: this.mustUpload(user[1]),
        Expired: this.isExpired(user[1]),
      }
      let tobeActivate = this.isActivate(user[0]) && this.isActivate(user[1]);
      this.setState({
        user_1, user_2,
        dualCards: true,
        tobeActivate,
      });
      this.setState({ loadedData: true });
    } else {
      let user_1 = {
        Active: this.isActive(user[0]),
        Activate: this.isActivate(user[0]),
        Block: this.isBlocked(user[0]),
        Upload: this.canUpload(user[0]),
        UploadAlert: this.mustUpload(user[0]),
        Expired: this.isExpired(user[0]),
      }
      let tobeActivate = this.isActivate(user[0]);
      this.setState({
        user_1,
        dualCards: false,
        tobeActivate,
      });
      this.setState({ loadedData: true });
    }

    //if user is adult and want to ski for more than 8 days, if he does not have picture, this notice apeares
    this.check8dayNotice();

    //to show the price on the button
    this.checkServicePriceFor2ndCard();

  }

  checkServicePriceFor2ndCard() {
    let access_token = cookies.get('access_token');
    let params = {
      service: "sci",
      portal: 'sci',
      type: 'second_card',
      date_of_birth: this.state.user[0].birthday,
    }
    getServicePrice(this, access_token, params)
      .then((response) => {
        console.log("[MainPnl] getServicePrice @response: ", response);
        if (response == "fail" || response < 0) {
          // this.setState({
          //     errorFlg: true,
          //     errmsg: response.message
          // });
        } else {
          //success case!
          this.setState({ oncardPrices: formatter.format(response) })
        }
      });

  }

  cardPnlResponse(info, params) {
    console.log("CardPnl:", info);
    switch (info) {
      case "blockButton":
        // this.props.doBlock();
        this.mpcallback({ option: "block" });

        break;
      case "replaceCard":
        this.mpcallback({ option: "replaceCard" });
        break;
      case "cardValidationError":
        this.mpcallback({ option: "cardValidationError", params });
        break;
    }
  }

  mpcallback(info) {
    console.log("mpcallback:", info);
    this.props.mpcallback(info);
  }

  // set Expired props for skier
  // check if card has expired
  isExpired = (item) => {
    if (!this.isActivate(item)) {
      let today = new Date();
      let expiration = new Date(item.data_scadenza);
      console.log('ACTIVE: ' + item.id + ' isExpired', (today.getTime() > expiration.getTime()))
      return (today.getTime() > expiration.getTime());
    } else {
      return false
    }
  }


  // set Block props for user
  isBlocked = (item) => {
    return (!!item.card_blocked || !!item.ticket_blocked);


  }

  // set Activate prop 
  isActivate = (item) => {
    return (item.code == '' || item.type == null || item.code == 'new');
  }

  // check id skier must upload documents
  mustUpload = (item) => {
    return !((item.certified == 1) || this.isAdultFromBirthday(item))
  }

  //if user has not upload documents yet(optional for adult)
  canUpload = (item) => {
    return !item.certified
  }

  // check if skier must upload documents
  isAdult = (item) => {
    console.log("isAdult: ", item);
    return (item.type.toLowerCase() == 'adult')
  }

  isU24 = (item) => {
    console.log("isU24: ", item);
    return (item.type.toLowerCase() == 'under24')
  }

  isAdultFromBirthday = (item) => {
    var today = new Date();

    var dd = today.getDate();
    var mm = today.getMonth(); //January is 0!
    var yyyy = (mm < 6) ? today.getFullYear() - 1 : today.getFullYear();
    var yyyy2 = new Date(item.birthday).getFullYear();

    return yyyy - yyyy2 >= 24 && yyyy - yyyy2 < 65;
  }

  // check if card isActive
  // !Block || !Activate
  isActive = (item) => {
    console.log('isactive item printing', this.isActivate(item), item);

    return (!this.isActivate(item) && !this.isBlocked(item));
  }

  autopayModified = (flag, param) => {
    console.log("autopayModified", flag, param);

    this.setState({
      isLoading: flag,
      rinnovo_automatico: param == "checked" ? 1 : 0,

    });

    if (param || param === '') this.mpcallback({ option: "autopayModified" });
  }

  //check if skier has picture
  hasSkierPicture = () => {
    let user = this.state.user[0];
    console.log("hasSkierPicture", user.picture);
    return !!user.picture
  }

  //if user is adult and want to ski for more than 8 days, if he does not have picture, this notice apeares
  check8dayNotice = () => {
    let user = this.state.user[0];
    if (this.isAdultFromBirthday(user) && !this.hasSkierPicture()) {
      this.setState({ remUpload: true });
    }
  }

  getUserProfilePicture = files => {
    console.log(files.base64);
    this.setState({
      profileLoader: true,
      userProfilePicture: files.base64,
      remUpload: false,
    }, () => {
      this.updateSkierPicture();
    });
  }

  updateSkierPicture = () => {
    let profileParams = {
      type: 'back',
      image: this.state.userProfilePicture.split(',')[1],
      linked_user_id: this.state.user[0].id
    }
    updateSkierPictureFetch(this, profileParams).then((response_profile) => {
      this.setState({ profileLoader: false });
      console.log(response_profile);
    });
  }


  //     <MainPnl
  //     User={this.state.activeSkier}
  //     // Active={this.isActive(this.state.activeSkier)}
  //     // Activate={this.isActivate(this.state.activeSkier)}
  //     // Block={this.isBlocked(this.state.activeSkier)}
  //     // Upload={this.canUpload(this.state.activeSkier)}
  //     // UploadAlert={this.mustUpload(this.state.activeSkier)}
  //     // Expired={this.isExpired(this.state.activeSkier)}
  //     mpcallback={this.mpcallback}
  //     dualCards={false}
  // />


  //add 2nd card to the same skier
  addSecondSkicard(item) {
    localStorage.setItem("limitedPurchase", item);
    localStorage.setItem("linkedUser", JSON.stringify(this.state.user[0]));

    this.mpcallback({ option: "addSecondCard" });
  }

  insertPostalCode = () => {
    console.log("insertPostalCode postalcode: ", this.state.postalcode_variable);
    let postalCodeParams = {
      postalcode: this.state.postalcode_variable,
      linked_user_id: this.state.user[0].id
    }
    this.setState({ postalCodeLoader: true });
    console.log("insertPostalCode postalCodeParams: ", postalCodeParams);

    // setTimeout(() => {
    //     this.setState({postalCodeLoader: false});
    // }, 2000);

    setSkierPostalCode(this, postalCodeParams).then((response) => {
      this.setState({ postalCodeLoader: false });
      console.log("setSkierPostalCode response: ", response);
      try {
        if (response.status == "fail") {
          // popup
          alert(response.message);

        } else {
          // success
          //  updating skier
          let certified = response.certified_postalcode ? response.certified_postalcode : 2; // 2: certification not needed
          this.setState({ certified_postalcode: certified, postalcode: this.state.postalcode_variable });
        }
      } catch (error) {
        console.log("setSkierPostalCode error: ", error);
      }
    });
  }

  render() {
    console.log('[MainPnl] states: ', this.state);
    const { certified_postalcode, postalcode, postalCodeLoader, postalcode_variable } = this.state;

    const PostalCodeBlock = () => {
      // postal code available
      if (postalcode) {
        if (certified_postalcode === 0) {
          // not certified (warning)
          return (
            <div className="postalcode-container">
              <div className="alertsMI1">
                <img src={alerts} className="img-fluid" />
              </div>
              <div style={{ marginRight: 10, }}>
                {postalcode}
              </div>
              <button className="sbtn1-small" onClick={() => this.mpcallback({ option: 'upload', type: "zip" })}>{tr.t("Uploaddoc")}</button>
            </div>
          )
        }
        if ((certified_postalcode === 1) || (certified_postalcode === 2) || (!certified_postalcode)) {
          // certified || certification not needed
          return postalcode;
        }
        if (certified_postalcode === 3) {
          // data sent, certification in progress
          return (
            <div className="postalcode-container">
              <div className="alertsMI1">
                <img src={pending} className="img-fluid" />
              </div>
              {postalcode}
            </div>
          )
        }
      }
      // no postalcode available
      // asking user to insert
      return (
        postalCodeLoader ?
          <ReactLoading color={"#17106a"} className="loading-mainpnl-pp" type={'spin'} delay={15} width={25} />
          :
          <div className="postalcode-container">
            <div className="alertsMI1">
              <img src={alerts} className="img-fluid" />
            </div>
            <Cleave
              className={"txtStyleID2"}
              style={{ borderBottomColor: 'rgba(255, 255, 255, 0.7)', borderBottomWidth: 2, }}
              options={{
                blocks: [10],
                numericOnly: true
              }}
              value={postalcode_variable}
              onChange={(e) => this.setState({ postalcode_variable: e.target.value })}
              placeholder={tr.t("Postalcode")}
            />
            <button disabled={!postalcode_variable} className="sbtn1-small" onClick={this.insertPostalCode}>{tr.t("Confirm")}</button>
          </div>
      )
    }
    return (
      <div>
        {
          this.state.loadedData && <div className="row">
            <div className="col">
              <div className="sn_ua__container p-4 p-md-5 sn_ua__resp">
                <div className="row pb-5">
                  <div className="col-6">
                    <div className="sn_profile_wrap">
                      <div className="profilem">
                        {
                          !this.state.userProfilePicture ? <Avatar src={this.state.userPic ? this.state.userPic : profilee} className="responsiveProfilem" size={'100%'} round="50%" /> :
                            <Avatar src={this.state.userProfilePicture} className="responsiveProfilem" size={'100%'} round="50%" />
                        }
                        {
                          this.state.profileLoader && <ReactLoading color={"#17106a"} className="loading-mainpnl-pp" type={'spin'} delay={15} width={25} />
                        }
                      </div>
                      {
                        this.state.remUpload &&
                        <div className="profilemu">
                          <ReactFileReader base64={true} handleFiles={this.getUserProfilePicture}>
                            <a><img src={uploadpicoverlay} className="img-fluid" /></a>
                          </ReactFileReader>
                        </div>
                      }
                    </div>
                  </div>
                  <div className="col-6 d-flex justify-content-end">
                    <button className="minimizeBtn" onClick={() => this.mpcallback({ option: "minimize" })}></button>
                  </div>
                  <div className="col-12 col-xl mt-5">
                    <div className="row">
                      <div className="col-12 col-lg-6">
                        <div className="row mb-4">
                          <div className="col-auto">
                            <div className="lineMTti">{tr.t("Name")}:</div>
                          </div>
                          <div className="col">
                            <div className="lineMT">
                              {this.state.user[0].name}
                            </div>
                          </div>
                        </div>

                        <div className="row mb-4">
                          <div className="col-auto">
                            <div className="lineMTti">{tr.t("Surname")}:</div>
                          </div>
                          <div className="col">
                            <div className="lineMT">
                              {this.state.user[0].surname}
                            </div>
                          </div>
                        </div>

                        <div className="row mb-4">
                          <div className="col-auto">
                            <div className="lineMTti">{tr.t("Born")}</div>
                          </div>
                          <div className="col">
                            <div className="lineMT">
                              {((this.canUpload(this.state.user[0]) && !this.isAdultFromBirthday(this.state.user[0])) || this.state.user[0].certified == 1 && !this.state.user[0].picture) ?
                                <button className="sbtn1" onClick={() => this.mpcallback({ option: 'upload' })}>{tr.t("Uploaddoc")}</button> : null
                              }
                              {this.state.user[0].birthday.split('-')[2] + '/' + this.state.user[0].birthday.split('-')[1] + '/' + this.state.user[0].birthday.split('-')[0]}
                              {((this.state.user[0].certified != 3 && this.mustUpload(this.state.user[0])) || this.state.user[0].certified == 1 && !this.state.user[0].picture) ?
                                <div className="alertsMI1">
                                  <img src={alerts} className="img-fluid" />
                                </div> : null
                              }
                              {this.state.user[0].certified == 3 ?
                                <div className="pending">
                                  <img src={pending} className="img-fluid" />
                                </div> : null
                              }
                            </div>
                          </div>
                        </div>

                        <div className="row mb-4">
                          <div className="col-auto">
                            <div className="lineMTti">{tr.t("Postalcode")}:</div>
                          </div>
                          <div className="col">
                            <div className="lineMT">
                              {PostalCodeBlock()}
                            </div>
                          </div>
                        </div>

                        <div className="row mb-4">
                          <div className="col-auto">
                            <div className="lineMTtibl">{tr.t("Status")}
                            </div>
                          </div>
                          <div className="col" style={window.innerWidth > 1500 ? { paddingLeft: window.innerWidth * 0.050 } : {}}>
                            {
                              this.state.user[0].portale === 'ambassadorsci' ?
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', zIndex: 100 }} className='row'>
                                  <img style={{ width: 40, height: 20, position: 'absolute', zIndex: 100, right: 20 }} src={require('../../../images/public/ambassador/infiniteWhite.png')} />
                                </div>
                                :
                                <div className="lineMTbl">
                                  {this.state.tobeActivate ?
                                    //FIXME: 'to be activate' if both cards are not active//TODO: implement for case that we have 2 cards.
                                    <div className="txtStyle1">{tr.t("Activate")}</div> : null
                                  }
                                  {this.isExpired(this.state.user[0]) ?
                                    //FIXME:if service is expired
                                    <div className="flexBox">
                                      {/* <div className="alertsMI2"> */}
                                      {/* </div> */}
                                      <p style={{ margin: 0 }}>
                                        {tr.t("Expired")} {this.state.user[0].data_scadenza ? (this.state.user[0].data_scadenza.split('-')[2] + '/' + this.state.user[0].data_scadenza.split('-')[1] + '/' + this.state.user[0].data_scadenza.split('-')[0]) : "!"}
                                      </p>
                                      <img src={alerts} className="img-fluid" style={{ width: 18, marginRight: 5 }} />

                                    </div> :
                                    !this.isActivate(this.state.user[0]) ?
                                      <div className="txtStyle1">{tr.t("Active")}&#160;{this.state.user[0].data_scadenza.split('-')[2] + '/' + this.state.user[0].data_scadenza.split('-')[1] + '/' + this.state.user[0].data_scadenza.split('-')[0]}</div> : null
                                  }
                                </div>
                            }
                          </div>
                        </div>

                        {
                          this.state.user[0].portale !== 'ambassadorsci' &&
                          <div>
                            <div className="row mb-4">
                              <div className="col-auto">
                                <div className="lineMTtil">{tr.t("Renewal")}
                                  {this.state.isLoading && <ReactLoading className="loading-mainpnl" type={'spin'} delay={15} width={25} />}
                                </div>
                              </div>
                              <div className="col">
                                <div className="lineMTl">
                                  <ToggleBtn id={this.state.user[0].id} active={this.state.rinnovo_automatico} autopayModified={this.autopayModified.bind(this)} />
                                </div>
                              </div>
                            </div>
                            <div className="row mb-3">
                              <div className="col-6 mb-4">
                                <div className="lineMTtileb">
                                  <button className="sn_btn sn_minibutton" onClick={() => this.mpcallback({ option: "renew" })}>{tr.t("Renew")}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        }

                        {this.state.remUpload &&
                          <div className="row">
                            <div className="col-12 mb-4 mb-lg-0">
                              <div className="lineMTtile">
                                <div className="alertsMI3">
                                  <img src={alertblu} className="img-fluid" />
                                </div>
                                {tr.t("Remember")}
                              </div>
                            </div>
                          </div>
                        }


                      </div>

                      <div className="col-12 col-lg-6">
                        <div className="containerCard">
                          <div className="containerCard1" style={{ paddingBottom: '10%' }}>
                            <CardPnl
                              activeSkier={this.state.user[0]}
                              Activate={this.isActivate(this.state.user[0])}
                              Active={this.isActive(this.state.user[0])}
                              Block={this.isBlocked(this.state.user[0])}
                              Expired={this.isExpired(this.state.user[0])}
                              cardIndex={0}
                              callback={this.cardPnlResponse.bind(this)}
                            />
                          </div>
                          {this.state.dualCards &&
                            <div className={this.isBlocked(this.state.user[0]) ? "containerCard2b" : "containerCard2"}>
                              <CardPnl
                                activeSkier={this.state.user[1]}
                                Activate={this.isActivate(this.state.user[1])}
                                Active={this.isActive(this.state.user[1])}
                                Block={this.isBlocked(this.state.user[1])}
                                Expired={this.isExpired(this.state.user[1])}
                                cardIndex={1}
                                callback={this.cardPnlResponse.bind(this)}
                              />
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 d-flex justify-content-center">
                    {!this.state.dualCards ?
                      <div> {/* TODO: @Ali: I removed the expiration state, because with the new place for the "Renew" button we always should have this button when user does not have the second card (You can see the old code below). tnx */}
                        {
                          this.state.user[0].provider.toLowerCase() == 'skidata' ?
                            <button className="sn_btn_standard" onClick={() => this.addSecondSkicard('axess')}>{tr.t("Requestpa")} {this.state.oncardPrices}</button> :
                            <button className="sn_btn_standard" onClick={() => this.addSecondSkicard('skidata')}>{tr.t("Requestnpa")} {this.state.oncardPrices}</button>
                        }
                      </div> : null
                    }
                    {/* {!this.state.dualCards ?
                              <div>
                                  {!this.isExpired(this.state.user[0]) ?
                                      <div>
                                          <div>
                                              {
                                                  this.state.user[0].provider.toLowerCase() == 'skidata' ?
                                                      <button className="bbtnp" onClick={() => this.addSecondSkicard('axess')}>{tr.t("Requestpa")}</button> :
                                                      <button className="bbtnp" onClick={() => this.addSecondSkicard('skidata')}>{tr.t("Requestnpa")}</button>
                                              }
                                          </div>
                                      </div> : null
                                  }
                              </div> : null
                          } */}
                    {/* {this.isExpired(this.state.user[0]) ?
                              //FIXME: if card is expired this is shown. If we have 1 card, the add new card btn is replaced.
                              <div>
                                  <button className="bbtnr" onClick={() => this.mpcallback({ option: "renew" })}>{tr.t("Renew")}</button>
                              </div> : null
                          } */}
                  </div>
                </div>
              </div>

            </div>
          </div>}

      </div>
    );
  }
}

export default MainPnl;

function is30DayBefore(expiration_date) {

  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth(); //January is 0!

  var yyyy = today.getFullYear();

  let startDateArray = expiration_date.replace(/[\s]+/g, '-').replace(/[:]+/g, '-').split('-');

  console.log(yyyy, mm, dd, Number(startDateArray[0]), Number(startDateArray[1]), Number(startDateArray[2]));

  var todayMoment = moment([yyyy, mm, dd]);
  var expMoment = moment([Number(startDateArray[0]), Number(startDateArray[1] - 1), Number(startDateArray[2])]);

  let diffDays = expMoment.diff(todayMoment, 'days');

  console.log(diffDays);

  return diffDays < 31;
}


// WEBPACK FOOTER //
// ./src/assets/components/panel/MainPnl.js